/** CoTaskr Plan (pm) — flat $10/seat/mo after 30-day trial */
export { PLAN_PRICE_USD_PER_SEAT, PLAN_TRIAL_DAYS } from '@/config/pricing';

export const PLAN_INCLUDED_FEATURES = [
  '30-day full-feature trial, then flat $10/seat/mo',
  'Board, backlog, sprints, milestones, calendar & timesheet',
  'Dashboard, handbook & team management',
  'AI Studio, Whiteboard & task writing tools (monthly AI quota applies)',
  'Gantt, workload, reports & stakeholder views',
  'Slack & GitHub integrations',
  'ATTACHMENT_LIMIT', // resolved at render time via i18n key attachments.planFeature
  'Priority support on paid Plan',
] as const;
export const ENTERPRISE_FEATURES = [
  'SSO / SAML, API & webhooks',
  'Custom roles & white-label',
  'Dedicated account manager',
  'Custom storage & AI terms',
] as const;
